export default{
    getAppData(state,getters){
        return state.appData;
    }
};